export const windowWidth =
  typeof window !== `undefined` ? window.innerWidth : null;

export const windowHeight =
  typeof window !== `undefined` ? window.innerHeight : null;
